import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';
import { SideNav } from './components/SideNav/SideNav';
import { useAuth } from './hooks';

const Layout = styled('div')`
  height: 100%;
  width: 100%;

  display: grid;

  grid-template-areas: 'side-nav content';

  grid-template-rows: 1fr;

  grid-template-columns: min-content auto;

  min-height: 0;
`;

/**
 * Layout route for the clinician (Care OS) experience: the fixed SideNav
 * plus the routed page in the content area. Used as a react-router layout
 * route (renders `<Outlet />`), so any route nested under it gets this
 * chrome. Routes that are *not* part of the clinician experience (e.g. the
 * design-system audit) sit outside it in `Root`.
 */
export const AppLayout = () => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <Layout data-test={'app-layout'}>
      <SideNav />

      <Outlet />
    </Layout>
  ) : (
    <div>
      <Outlet />
    </div>
  );
};
